import script from "./PowerupMeta.vue?vue&type=script&lang=js"
export * from "./PowerupMeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1947b21e"]])

export default __exports__